module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres2-ef0d0e49d7e1ad73a775e333458015eb.jpg";